import React from 'react';
import './FilePreviewModal.css';

const FilePreviewModal = ({ isOpen, onClose, fileUrl, fileName }) => {
    if (!isOpen || !fileUrl) return null;

    const handleDownload = async () => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'document';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            alert('파일 다운로드 실패');
        }
    };

    return (
        <div className="file-preview-overlay" onClick={onClose}>
            <div className="file-preview-content" onClick={(e) => e.stopPropagation()}>
                <div className="file-preview-header">
                    <h3>{fileName || '문서 미리보기'}</h3>
                    <div className="file-preview-actions">
                        <button onClick={handleDownload} className="file-preview-btn download-btn">
                            💾 다운로드
                        </button>
                        <button onClick={onClose} className="file-preview-close">
                            ✕
                        </button>
                    </div>
                </div>
                <div className="file-preview-body">
                    <iframe
                        src={fileUrl}
                        title="Document Preview"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default FilePreviewModal;
